import { useQuery } from "react-query";

import { getUserSubscriptionData } from "../utils";
import { AppConfig } from "../../../configs/config";
import { ALL_QUERY_KEY } from "../../../constants/action";
import { getPackages } from "../../../scripts/dataHandlers";
import { useMyContext } from "../../../contexts/StateHolder";
import { reactQueryGetUser } from "../../../scripts/dataHandlerReactquery";

export const useGetUserSubscription = () => {
	const { user } = useMyContext();
	const userId = user?.userId * 1;
	const token = user?.userToken;
	const organizationId = user?.organizationId;

	const query = useQuery({
		queryKey: [
			ALL_QUERY_KEY.GET_USER_SUBSCRIPTION,
			{
				organizationId: organizationId,
				userId,
			},
		],

		queryFn: async () => {
			const [packages, user] = await Promise.all([
				getPackages(
					organizationId,
					"fi_FI",
					undefined,
					token,
					AppConfig.recurringShoppingCategoryId
				),

				reactQueryGetUser(organizationId, token),
			]);

			return { packages, user: user?.data };
		},

		select: (res) => {
			console.log("res", res);

			return getUserSubscriptionData(res);
		},
		enabled: organizationId > 0,

		// refetchInterval: 5 * 60 * 1000, // evrery 5 minutes

		// refetchIntervalInBackground: false,
	});

	return query;
};
